import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { Color } from '@components/reservationGrid/components/colorPicker/colorPicker'
import { Tarif } from '@facades/reservation'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const ReservationRowItem = styled.div<{
  forceDesktopLayout?: boolean
}>`
  display: flex;
  width: ${(props) => (props.forceDesktopLayout ? '100%' : 'auto')};

  @media screen and (max-width: 990px) {
    flex-direction: ${(props) => (props.forceDesktopLayout ? 'row' : 'column')};
  }

  @media screen and (max-width: 720px) {
    flex-direction: column;
  }

  @media screen and (max-width: 900px) and (hover: none) and (pointer: coarse),
    (horizontal-viewport-segments: 2) {
    flex-direction: column;
  }

  @container birthday-grid (max-width: 720px) {
    flex-direction: column;
  }
`

export const ReservationRowItemTime = styled(ReservationRowItem)`
  @media screen and (max-width: 990px) {
    display: none;
  }
`

export const ReservationSystemGrid = styled.div<{
  forceDesktopLayout?: boolean
}>`
  display: flex;
  flex-direction: column;
  width: ${(props) => (props.forceDesktopLayout ? '100%' : 'min-content')};

  @media screen and (max-width: 990px) {
    width: ${(props) => (props.forceDesktopLayout ? 'min-content' : '100%')};
  }

  @media screen and (max-width: 720px) {
    width: 100%;
  }

  @media screen and (max-width: 900px) and (hover: none) and (pointer: coarse),
    (horizontal-viewport-segments: 2) {
    width: 100%;
  }

  @container birthday-grid (max-width: 720px) {
    width: 100%;
  }
`

export const ReservationItemContainer = styled.div<{
  withTrigger?: boolean
  isCanceled?: boolean
  isSelected?: boolean
  isGroupReservation?: boolean
}>`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${(props) =>
    props.withTrigger &&
    css`
      border: 2px solid #5f2a9b;
      padding: 2px;
      margin: 2px;
      border-radius: 4px;
      background: radial-gradient(
        circle,
        rgba(95, 42, 155, 1) 0%,
        rgba(8, 83, 94, 1) 50%,
        rgba(95, 42, 155, 1) 100%
      );
    `}

  ${(props) =>
    props.isSelected &&
    css`
      border-color: white;
    `}
`

export const ReservationItemContainerTimeItem = styled.span<{
  forceDesktopLayout?: boolean
}>`
  display: none;
  color: white;

  @media screen and (max-width: 990px) {
    display: ${(props) => (props.forceDesktopLayout ? 'none' : 'block')};
  }
`

export const ReservationDateItem = styled.span<{
  isWeekend?: boolean
  selected?: boolean
  isPlaceholder?: boolean
  hoverable?: boolean
  forceDesktopLayout?: boolean
}>`
  padding: 8px;
  width: 100%;
  min-width: 200px;
  max-width: 200px;
  margin-bottom: 2px;
  margin-top: 2px;
  margin-right: 10px;
  background: ${(props) => (props.isWeekend ? '#353c4b' : '#202327')};
  text-align: center;
  color: #b7c1d3;
  font-size: 14px;
  user-select: none;

  @media screen and (max-width: 990px) {
    width: ${(props) => (props.forceDesktopLayout ? '100%' : '100%')};
    max-width: ${(props) => (props.forceDesktopLayout ? '200px' : 'unset')};
    margin-bottom: ${(props) => (props.forceDesktopLayout ? '2px' : '10px')};
  }

  @media screen and (max-width: 720px) {
    width: 100%;
    max-width: unset;
    margin-right: 0;
    margin-bottom: 10px;
  }

  @media screen and (max-width: 900px) and (hover: none) and (pointer: coarse),
    (horizontal-viewport-segments: 2) {
    width: 100%;
    max-width: unset;
    margin-right: 0;
    margin-bottom: 10px;
  }

  @container birthday-grid (max-width: 720px) {
    width: 100%;
    max-width: unset;
    margin-right: 0;
    margin-bottom: 10px;
  }

  ${(props) =>
    props.selected &&
    css`
      background: red;
      color: white;
    `}

  ${(props) =>
    props.isPlaceholder &&
    css`
      background: transparent;
    `}

  ${(props) =>
    props.hoverable &&
    css`
      cursor: pointer;
    `}
`
export const ReservationSelectableRow = styled.div<{
  forceDesktopLayout?: boolean
}>`
  display: flex;
  min-width: 0;
  flex: ${(props) => (props.forceDesktopLayout ? '1 1 auto' : 'initial')};
  align-items: center;
  align-content: flex-start;
  flex-wrap: nowrap;

  @media screen and (max-width: 990px) {
    width: ${(props) => (props.forceDesktopLayout ? 'auto' : '100%')};
    justify-content: ${(props) =>
      props.forceDesktopLayout ? 'initial' : 'center'};
    flex-wrap: ${(props) => (props.forceDesktopLayout ? 'nowrap' : 'wrap')};
  }

  @media screen and (max-width: 720px) {
    width: 100%;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  @media screen and (max-width: 900px) and (hover: none) and (pointer: coarse),
    (horizontal-viewport-segments: 2) {
    width: 100%;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  @container birthday-grid (max-width: 720px) {
    width: 100%;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
`

export const ReservationTimeItem = styled.span`
  min-width: 70px;
  width: 70px;
  margin-right: 3px;
  margin-left: 3px;
  text-align: center;
  color: white;
  font-size: 16px;
  user-select: none;
`

const ItemColor = {
  low: '#3eafdb',
  medium: '#8ec051',
  high: '#533bff',
  booked: '#24262a',
  selected: 'red',
}

export const ReservationSelectableItem = styled.span<{
  tarif?: Tarif
  selected?: boolean
  color?: Color
  isGroupReservation?: boolean
}>`
  display: flex;
  background: ${(props) =>
    props.color
      ? props.color
      : props?.tarif
      ? ItemColor[props.tarif]
      : ItemColor.low};
  padding: 2px;
  border-radius: 4px;
  min-width: 70px;
  width: 70px;
  margin-right: 3px;
  margin-left: 3px;
  height: min-content;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  color: ${(props) => (props.tarif !== Tarif.Booked ? '#fff' : '#343a48')};
  user-select: none;

  ${(props) =>
    !props.isGroupReservation &&
    props.selected &&
    css`
      background: red;
      color: white;
    `}

  ${(props) =>
    props.isGroupReservation &&
    !props.color &&
    props.selected &&
    css`
      background: linear-gradient(
        4deg,
        rgba(95, 42, 155, 1) 0%,
        rgba(87, 182, 199, 1) 50%,
        rgba(95, 42, 155, 1) 100%
      );
      color: white;
    `}
`

export const PaginationButton = styled.button<{ top?: boolean }>`
  background: unset;
  width: fit-content;
  border: unset;
  cursor: pointer;
  color: white;
  font-size: 18px;
  padding: 30px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  user-select: none;

  svg {
    transform: ${(props) => (props.top ? 'rotate(90deg)' : 'rotate(270deg)')};
  }

  &:hover {
    color: #ff8e00;
  }
`

export const ButtonPlaceholder = styled.div`
  height: 105px;
`

export const DropdownTrigger = styled.div<{
  isDisabled?: boolean
  isDropdownOpen?: boolean
  isError?: boolean
}>`
  background: white;
  display: flex;
  min-width: 70px;
  width: 70px;
  padding: 2px;
  border-radius: 4px;
  font-size: 16px;
  user-select: none;
  margin: 5px 3px;
  cursor: pointer;
  position: relative;
  border: 1px solid transparent;
  color: #343a48;

  ${(props) =>
    props.isDisabled &&
    css`
      background: grey;
    `}

  & > .triggerIcon {
    transform: rotate(270deg);
  }

  ${(props) =>
    props.isDropdownOpen &&
    css`
      & > .triggerIcon {
        transform: rotate(90deg);
      }
    `}

  ${(props) =>
    props.isError &&
    css`
      border: 1px solid red;
    `}
`

export const DropdownTriggerTitle = styled.span`
  width: 50px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Dropdown = styled.div`
  position: absolute;
  top: 30px;
  z-index: 99999999;
  background: white;
  right: 0;
  border: 1px solid grey;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  min-width: 100%;
`

export const DropdownItem = styled.span<{
  isDisabled?: boolean
  isCancel?: boolean
  isItemSelected?: boolean
}>`
  padding: 5px;
  white-space: nowrap;
  text-align: right;
  transition:
    background-color 0.1s ease,
    color 0.1s ease;

  ${(props) =>
    props.isItemSelected &&
    css`
      color: #fff;
      background-color: #337ab7;
    `}

  ${(props) =>
    !props.isDisabled &&
    css`
      &:hover {
        color: #fff;
        background-color: #337ab7;
      }
    `}

  ${(props) =>
    props.isDisabled &&
    css`
      color: grey;
    `}
    
    ${(props) =>
    props.isCancel &&
    css`
      background: red;
      color: white;
      width: fit-content;
      align-self: flex-end;
      border-radius: 10px;
      margin: 10px;
    `}
`
